import templateUrl from './edit-user-connected-accounts.component.html';

/**
 * A component that allows IDs for connected accounts for the user
 * to be inputted directly.
 */
export const EditUserConnectedAccountsComponent = {
    templateUrl,
    require: {
        editForm: "?^^form"
    },
    bindings: {
        user: "<"
    }
};
